import { render } from "./SwapInner.vue?vue&type=template&id=ee23fdb0&scoped=true"
import script from "./SwapInner.vue?vue&type=script&lang=js"
export * from "./SwapInner.vue?vue&type=script&lang=js"

import "./SwapInner.vue?vue&type=style&index=0&id=ee23fdb0&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee23fdb0"],['__file',"resources/js/components/SwapInner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee23fdb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee23fdb0', __exports__)) {
    api.reload('ee23fdb0', __exports__)
  }
  
  module.hot.accept("./SwapInner.vue?vue&type=template&id=ee23fdb0&scoped=true", () => {
    api.rerender('ee23fdb0', render)
  })

}


export default __exports__